const statusOptions = [
  { value: 'uploaded', text: 'uploaded', icon: 'file' },
  { value: 'annotated', text: 'annotated', icon: 'object-group' },
  { value: 'reviewed', text: 'reviewed', icon: 'check' },
  { value: 'ignored', text: 'ignored', icon: 'ban' },
]

export default statusOptions
